import types from 'actions/types'
import {createPivotTableReducer} from 'reducers/pivotTable'
import {combineReducers} from 'redux'
import {getFilterFromAction} from 'helpers/reducer'

export const showAllRevisions = (state = false, action) => {
  switch (action.type) {
    case types.QUOTING_PURCHASING_UPDATE_FILTERS:
      return getFilterFromAction(state, action, 'showAllRevisions')
    default:
      return state
  }
}

export const purchasingTabPivotTableKey = 'quotingContext.selected.purchasingTab.pivotTable'

export default combineReducers({
  showAllRevisions,
  pivotTable: createPivotTableReducer({
    key: purchasingTabPivotTableKey,
    defaultSortColumn: 'createdDate',
    defaultSortDirection: 'desc',
  }),
})
